var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',_vm._b({attrs:{"value":_vm.open},on:{"input":_vm.close}},'v-dialog',_vm.dialogProps,false),[(_vm.params)?_c(_vm.params.component,_vm._g(_vm._b({tag:"div"},'div',_vm.params.props,false),_vm.params.listeners)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }